import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const StatementBand = () => {
  const { t } = useLang();
  const h = t.hype;

  return (
    <div className="mx-auto mt-14 w-full max-w-6xl px-5 sm:mt-16 lg:px-8">
      <div className="mx-auto max-w-3xl text-center" data-testid="hype-band">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
          className="font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-violet-400"
          data-testid="hype-eyebrow"
        >
          {h.eyebrow}
        </motion.p>
        <div className="mt-4 font-display font-bold leading-[1.08] tracking-tight">
          {[h.lineA, h.lineB, h.lineC].map((line, i) => (
            <motion.span
              key={i}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
              className={
                "block text-[clamp(1.6rem,3.6vw,2.8rem)] " +
                (i === 0 ? "text-ink" : i === 1 ? "text-signal text-glow-signal" : "text-violet-400")
              }
              data-testid={`hype-line-${i}`}
            >
              {line}
            </motion.span>
          ))}
        </div>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-ink-muted sm:text-base"
          data-testid="hype-sub"
        >
          {h.sub}
        </motion.p>
      </div>
    </div>
  );
};

export default StatementBand;
